import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

import { Error } from '@rpe/registro-personas-empresas-lib';
import { MaquinaMovil } from './entity-maquinas-moviles.model';

export const entityMaquinaMovilAdapter: EntityAdapter<MaquinaMovil> =
  createEntityAdapter<MaquinaMovil>({
    selectId: (model) => model.id,
    sortComparer: (a: MaquinaMovil, b: MaquinaMovil): number =>
      b.id.toString().localeCompare(a.id.toString())
  });

export interface EntityMaquinaMovilState extends EntityState<MaquinaMovil> {
  isLoading?: boolean;
  hasAddedSuccess?: boolean;
  error?: Error | null | any;
}

export const initialState: EntityMaquinaMovilState =
  entityMaquinaMovilAdapter.getInitialState({
    hasAddedSuccess: false,
    isLoading: false,
    error: null
  });
